import React from 'react';
import AmountPriceContainer from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Containers/AmountPrice';
import { useSelector } from 'react-redux';
import { showReceiveOfferForm } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Selectors';
import ReceiveOfferForm from '../../Components/ReceiveOfferForm/ReceiveOfferForm';

const CustomAmountPriceContainer = (props) => {
  const {configurator} = useSelector(state => state.configurator);
  const query = new URLSearchParams(location.search);
  const isReceieveOffer = query.has('_cta_element')
            ? query.get('_cta_element') === 'requestOffer'
            : showReceiveOfferForm(configurator)
  return <AmountPriceContainer {...props} ReceiveOfferFormComponent={ReceiveOfferForm} displayAcceptDesign={isReceieveOffer} />;
};

export default CustomAmountPriceContainer;
